import { render } from "./StudentForm.vue?vue&type=template&id=3097bdac"
import script from "./StudentForm.vue?vue&type=script&lang=js"
export * from "./StudentForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__